import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@adsk/bim360-matrix-react-button';

import './_Dropdown.scss';

/**
 * A dropdown component. This component is a composition of a trigger button (Button) and menu component (DropdownMenu)
 * which are passed as children
 */
export default class Dropdown extends Component {
  /**
   * constructor
   */
  constructor(props) {
    super();

    this.state = {
      isOpen: false
    };

    this._handleOnButtonClick = this._handleOnButtonClick.bind(this);
    this.onItemSelect = this.onItemSelect.bind(this);
  }

  /**
   * react-clickoutside uses this as a callback (so it is indeed in use and you can ignore the WebStorm marking)
   */
  handleClickOutside() {
    this.closeMenu();
    if (this.props.onClickOutside) this.props.onClickOutside();
  }

  /**
   * closeMenu
   */
  closeMenu() {
    if (this.state.isOpen) this.toggleMenu();
  }

  /**
   * toggleMenu
   */
  toggleMenu() {
    this.setState({
      isOpen: !this.state.isOpen
    });

    if (this.props.onToggleMenu) {
      this.props.onToggleMenu();
    }
  }

  /**
   * _handleOnButtonClick
   */
  _handleOnButtonClick(event) {
    if (this.props.disabled) return;
    event.stopPropagation();
    event.preventDefault();
    this.toggleMenu();
  }

  /**
   * onItemSelect
   */
  onItemSelect(eventKey) {
    this.props.onSelect(eventKey);
    this.toggleMenu();
  }

  /**
   *
   * renderMenu
   */
  renderMenu(menu) {
    return React.cloneElement(menu, {
      onSelect: this.props.onSelect ? this.onItemSelect : undefined
    });
  }

  /**
   * renderChildren
   */
  renderChildren(children) {
    return React.Children.map(children, (child, i) => {
      switch (i) {
        case 0: // Button
          if (child.type === Button) {
            return React.cloneElement(child, {
              disabled: this.props.disabled,
              onClick: this._handleOnButtonClick
            });
          } else {
            return React.cloneElement(child, {
              onClick: this._handleOnButtonClick
            });
          }
        case 1: // DropdownMenu
          const isOpen = this.state.isOpen;
          const disabled = this.props.disabled;

          if (!disabled && isOpen) {
            return this.renderMenu(child);
          }

          return undefined;
        default:
          return undefined;
      }
    });
  }

  /**
   * render
   */
  render() {
    const cx = classNames('Dropdown', this.props.className);

    return <div className={cx}>{this.renderChildren(this.props.children)}</div>;
  }
}

Dropdown.propTypes = {
  /**
   * Whether the dropdown can be opened
   */
  disabled: PropTypes.bool,
  /**
   * A callback function for an menu item selection event
   */
  onSelect: PropTypes.func,
  /**
   * The children should be a Button and a DropdownMenu component in that order
   */
  children: PropTypes.arrayOf(PropTypes.element),
  /**
   * DEPRECATED: use `className` instead
   */
  cssClass: PropTypes.string,
  /**
   * A custom className for the container element of the component
   */
  className: PropTypes.string,
  /**
   * An optional function to be ran when toggle menu is called
   */
  onToggleMenu: PropTypes.func,
  /**
   * An optional function to be ran when menu get closed or click outside
   */
  onClickOutside: PropTypes.func
};
